import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { useTranslation } from '../../../../../src/i18n';
import Title from '../../../../../components/Title';
import { performancesAggregationTypes, TP } from '../../../../../constants/consts';
import FbCircularProgress from '../../../../../components/FbCircularProgress';
import ProductionListedCard from '../../../../../components/ProductionListedCard';
import FbPagination from '../../../../../components/FbPagination';
import SelectedProductionCard from '../../../../../components/EditComponents/SelectedProductionCard';
import AutocompleteSearchField from '../../../../../components/AutocompleteSearchField';

const useStyles = makeStyles(theme => ({
  titleBlock: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  productionsTitle: {
    marginRight: theme.spacing(1),
  },
  searchField: {
    maxWidth: '40%',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
    },
  },
}));

const ProductionsLinkBlock = ({
  selectedProduction,
  selectProduction,
  onCloseSelectedProduction,
  productionsList,
  getProductions,
  additionalInfoBlock,
  title,
  subtitle,
  searchProductions,
  searchProductionsList,
  isSearchLoading,
  onFocus,
  withSearchField,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [searchValue, setSearchValue] = React.useState('');

  const onSearchChange = v => {
    getProductions({ page: 1, limit: productionsList?.limit }, { [performancesAggregationTypes.workAgg]: v?.value });
    setSearchValue(v);
  };

  return (
    <div>
      {!selectedProduction && productionsList?.loadedOnce && (
        <div className={classes.titleBlock}>
          <div className={classes.productionsTitle}>
            <Title>{t(title)}</Title>
            {subtitle}
          </div>
          {withSearchField && (
            <AutocompleteSearchField
              className={classes.searchField}
              field={{ name: 'production-search', value: searchValue }}
              onInputTextChange={searchProductions}
              onFocus={onFocus}
              onChange={onSearchChange}
              options={searchProductionsList}
              isLoading={isSearchLoading}
            />
          )}
        </div>
      )}
      {selectedProduction ? (
        <SelectedProductionCard
          production={selectedProduction}
          onClose={onCloseSelectedProduction}
          additionalInfoBlock={additionalInfoBlock}
        />
      ) : (
        <>
          {productionsList?.loading ? (
            <FbCircularProgress />
          ) : (
            <>
              {productionsList?.data?.length > 0 ? (
                <>
                  <Grid container spacing={2}>
                    {productionsList?.data?.map(productionItem => (
                      <Grid item sm={12} key={productionItem?.id}>
                        <ProductionListedCard production={productionItem} onProductionSelect={selectProduction} />
                      </Grid>
                    ))}
                  </Grid>
                  <FbPagination filters={productionsList} fetchFunction={getProductions} />
                </>
              ) : (
                <div>{productionsList?.loadedOnce ? t(`${TP}.NO_RESULTS`) : ''}</div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

ProductionsLinkBlock.propTypes = {
  selectedProduction: PropTypes.object,
  selectProduction: PropTypes.func.isRequired,
  productionsList: PropTypes.object.isRequired,
  getProductions: PropTypes.func.isRequired,
  searchProductions: PropTypes.func,
  title: PropTypes.string,
  additionalInfoBlock: PropTypes.node,
  onFocus: PropTypes.func,
  withSearchField: PropTypes.bool,
};

ProductionsLinkBlock.defaultProps = {
  onFocus: () => {},
  searchProductions: () => {},
  withSearchField: true,
};

export default ProductionsLinkBlock;
